import axiosInstance from "../../../Services/Global-Services/UnauthorizedTokenHandler";
import {
  getHeaders,
  checkStatus
} from "../../../Services/SharedSevices/SharedServices";
const baseURL = process.env.REACT_APP_BASE_URL_TICKET;

// For fetching the record of Conversation Service.
export const GetEmpAssessmentPeriodList = async (params) => {
  try {
    const response = await axiosInstance.post(`${baseURL}/Performance/GetEmpAssessmentPeriodList`, params, {
      headers: await getHeaders(),
      body: JSON.stringify(params)
    });
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}

export const AddAssessmentPartFirst = async (params) => {
  try {
    const response = await axiosInstance.post(`${baseURL}/Performance/AddAssessmentPartFirst`, params, {
      headers: await getHeaders(),
      body: JSON.stringify(params)
    });
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}

// export const assessmentFetchPeriodList = async (params) => {
//   try {
//     const response = await axiosInstance.post(`${baseURL}/Performance/FetchPeriodList`, params, {
//       headers: await getHeaders(),
//       body: JSON.stringify(params)
//     });
//     checkStatus(response);
//     return response.data;
//   } catch (error) {
//     return Promise.reject(error);
//   }
// }


export const AssessmentSecondPart = async (params) => {
  try {
    const response = await axiosInstance.post(`${baseURL}/Performance/AddAssessmentPartSecond`, params, {
      headers: await getHeaders(),
      body: JSON.stringify(params)
    });
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}

export const getcriteriaList = async () => {
  try {
    const response = await axiosInstance.get(`${baseURL}/Performance/OrgAssessmentCriteria`, {
      headers: await getHeaders(),
    });
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }

}